import clientService from '../../../apiClient';
import { TEMPLATE } from '../../../utils/apiEndpoints';
import { Notification } from '../../Notification';

export const fetchTemplates = async ({ endpoint, params } = {}) => {
  try {
    const response = await clientService.get(`${TEMPLATE}${endpoint ? endpoint : ''}`, { params: params || {} });

    return response.data;
  } catch (error) {
    Notification.error('Unable to fetch templates', error?.data?.error?.message);

    return [];
  }
};

export const getTemplateById = async (templateId) => {
  try {
    const response = await clientService.get(`${TEMPLATE}/${templateId}`);

    return response.data;
  } catch (error) {
    Notification.error('Unable to fetch template', error?.data?.error?.message);

    return [];
  }
};

export const pinTemplate = async ({ templateId, body }) => {
  try {
    const response = await clientService.put(`${TEMPLATE}/${templateId}/pin`, body);

    return response;
  } catch (error) {
    Notification.error('Unable to update template', error?.data?.error?.message);

    return [];
  }
};

export const deleteTemplate = async ({ templateId }) => {
  try {
    const response = await clientService.delete(`${TEMPLATE}/${templateId}`);

    return response;
  } catch (error) {
    Notification.error('Unable to delete template', error?.data?.error?.message);

    return [];
  }
};

export const publishTemplate = async ({ body, id }) => {
  try {
    const response = await clientService.patch(`${TEMPLATE}/${id}`, body);

    return response;
  } catch (error) {
    Notification.error('Unable to publish template', error?.data?.error?.message);

    return [];
  }
};

export const trackTemplateUsage = async (id) => {
  try {
    const response = await clientService.put(`${TEMPLATE}/${id}/tracking`);
  } catch (error) {
    Notification.error('Unable to track template usage', error?.data?.error?.message);
  }
};
